// extracted by mini-css-extract-plugin
module.exports = {"w11adjj9":"w11adjj9"};